import React from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip, Legend } from 'recharts';

import YRTooltip from 'components/year-review/components/tooltip/YRTooltip';

import FormatGraphDataService from 'components/year-review/services/FormatGraphDataService';

import Config from 'components/year-review/constants/config';
import Colors from 'components/year-review/constants/colors';

const YRStackedBarChart = ({ data, style, isReady }) => {
    const {
        color,
        tooltipPrefix,
        tooltipSuffix,
        unit,
    } = style;

    const stackedBarsData = FormatGraphDataService.formatMultipleValues(data);

    return (
        <ResponsiveContainer width="100%" height={Config.chartHeight}>
            <BarChart
                data={stackedBarsData}
                margin={{
                    top: Config.margin,
                    left: Config.margin,
                    right: Config.margin,
                    bottom: Config.margin,
                }}
                focusable="false"
                key={isReady ? 0 : 1}
            >
                <CartesianGrid
                    vertical={false}
                    stroke={Colors.dnsLightGrey}
                    height={10}
                />
                <XAxis
                    dataKey="name"
                    tickLine={false}
                    stroke={Colors.dnsLightGrey}
                />
                <YAxis
                    dataKey="values0"
                    minTickGap={5}
                    interval={0}
                    tickLine={false}
                    stroke={Colors.dnsLightGrey}
                    unit={unit}
                />
                <Tooltip
                    content={
                        <YRTooltip
                            suffix={tooltipSuffix}
                            prefix={tooltipPrefix}
                            dataNames={data[0].values.map(x => x.name)}
                        />}
                />
                <Legend
                    payload={
                        data[0].values.map((x, i) =>
                            (
                                {
                                    value: x.name, type: 'circle', color: color[i],
                                }
                            ))
                    }
                />
                {stackedBarsData.map((barData, index) => (
                    <Bar
                        dataKey={`values${index}`}
                        fill={style.color[index]}
                        stackId="a"
                        animationBegin={Config.animationBegin}
                        animationDuration={Config.animationDuration}
                        animationEasing={Config.animationEasing}
                        key={barData.name}
                    />
                ))}
            </BarChart>
        </ResponsiveContainer>
    );
};

YRStackedBarChart.defaultProps = {
    style: {},
};

YRStackedBarChart.propTypes = {
    data: PropTypes.arrayOf(PropTypes.any).isRequired,
    isReady: PropTypes.bool.isRequired,
    style: PropTypes.objectOf(PropTypes.any),
};

export default YRStackedBarChart;
